import ahoy from "ahoy.js";
import { getUserId } from "./analytics/identification";
import { getSessionId } from "./analytics/sessions";
import { getOnPageValue } from "./analytics/track";
import { getVisitorId } from "./analytics/visitors";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Utilities
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

function requestHeaders(apiToken: string) {
  const headers: Record<string, string> = {
    "X-Dewey-Key": apiToken,
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  // Add Ahoy tokens for analytics correlation
  const visitId = ahoy.getVisitId();
  const visitorId = ahoy.getVisitorId();

  if (visitId) headers["Ahoy-Visit"] = visitId;
  if (visitorId) headers["Ahoy-Visitor"] = visitorId;

  return headers;
}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Search Configuration
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

const SEARCH_CONFIG_PATH = "/api/v0/search/configuration";

/**
 * Fetches the search configuration from the server
 * @param queryKey - The query key for the search configuration, made up of a path slug and the API token
 * @returns The search configuration
 */
export async function getSearchConfig({ queryKey }: { queryKey: [string, string, string] }): Promise<unknown> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, rootURL, apiToken] = queryKey;

  const url = new URL(`${rootURL}${SEARCH_CONFIG_PATH}`);
  url.searchParams.set("visitor_id", getVisitorId());
  url.searchParams.set("session_id", getSessionId());
  url.searchParams.set("on_page", getOnPageValue());
  url.searchParams.set("client_triggered_at", Date.now().toString());

  const userId = getUserId();
  if (userId) {
    url.searchParams.set("external_user_id", userId);
  }

  const response = await fetch(url, {
    method: "GET",
    headers: requestHeaders(apiToken),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message);
  }

  return await response.json();
}
